import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import store from './store'
import "./components";
import router from './router'
import ClientHttp from "./service/HttpService";
import HighchartsVue from 'highcharts-vue'

Vue.config.productionTip = false

const token = localStorage.getItem("token");

if (token) {
  ClientHttp.backApi.defaults.headers.common["X-Auth-Token"] = token;
}

new Vue({
  vuetify,
  store,
  router,
  render: h => h(App),
  HighchartsVue
}).$mount('#app')
